import * as React from "react";
import { NavLink } from "react-router-dom";

import classes from "../Navigation/Navigation.module.css";
import acdlogo from "../../images/ACD.svg";
import acd from "../../images/AmericanCommunityDevelopers.svg";

interface IState {
  collapsed: boolean;
}

class Navigation extends React.Component<{}, IState> {
  state = {
    collapsed: true,
  };

  toggleNavbar = () => {
    window.setTimeout(() => {
      this.setState({ collapsed: !this.state.collapsed });
    }, 500);
  };
  render() {
    return (
      <div className={classes["Navigation"]}>
        <p className={classes["AcdLogo"]}>
          <NavLink to="/">
            <img src={acdlogo} alt="ACD logo" />
            <img src={acd} alt="American Commmunity Developers" />
          </NavLink>
        </p>
        <div className={this.state.collapsed ? "" : classes["collapsed"]}>
          <i id="hamburger" className="fas fa-bars" onClick={this.toggleNavbar}></i>
        </div>
        <div className={this.state.collapsed ? classes["collapsed"] : ""}>
          <ul className={`${classes["menu"]} ${this.state.collapsed ? classes["hidemenu"] : ""}`}>
            <li>
              <i className="fas fa-times" onClick={this.toggleNavbar}></i>
            </li>
            <li>
              <NavLink to="/about" className={({ isActive }) => (isActive ? classes["active"] : undefined)}>
                ABOUT
              </NavLink>
            </li>
            <li>
              <NavLink to="/properties" className={({ isActive }) => (isActive ? classes["active"] : undefined)}>
                PROPERTIES
              </NavLink>
            </li>
            <li>
              <NavLink to="/team" className={({ isActive }) => (isActive ? classes["active"] : undefined)}>
                TEAM
              </NavLink>
            </li>
            <li>
              <NavLink to="/careers" className={({ isActive }) => (isActive ? classes["active"] : undefined)}>
                CAREERS
              </NavLink>
            </li>
            <li>
              <NavLink to="/partners" className={({ isActive }) => (isActive ? classes["active"] : undefined)}>
                PARTNERS
              </NavLink>
            </li>
            <li>
              <NavLink to="/green" className={({ isActive }) => (isActive ? classes["active"] : undefined)}>
                GREEN
              </NavLink>
            </li>
            <li>
              <NavLink to="/contact" className={({ isActive }) => (isActive ? classes["active"] : undefined)}>
                CONTACT
              </NavLink>
            </li>
            <li>
              <a href="http://download.acdmail.com/6">DOWNLOADS</a>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}

export default Navigation;
